import { Box, Grid, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import ContactForm from "./contactForm";
import ContactInfo from "./contactInfo";
import BusinessHours from "./businessHours";
import ButtonComponent from "../../../components/form/buttonComponent";
import { Link, useNavigate } from "react-router-dom";
import companyData from '../../../assets/data/company.json';

const ContactInfoLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('contact.title')}
                        description={t('contact.description')}
                    />
                
                    <Grid
                        direction={{xs: 'column', md: 'row'}}
                        justifyContent='center'
                        alignItems={{ xs: 'center', md: 'stretch' }}
                        container
                        width='100%'
                        spacing={{xs: 2, md: 5}}
                    >
                        {/* <Grid size={{xs: 12, md: 6}} sx={{ display: "flex" }}>
                            <ContactForm />
                        </Grid>

                        <Grid size={{xs: 12, md: 6}} sx={{ display: "flex" }}>
                            <Stack
                                direction='column'
                                justifyContent='center'
                                alignItems='space-between'
                                width='100%'
                                spacing={{xs: 2, md: 5}}
                            >
                                <ContactInfo />

                                <BusinessHours />
                            </Stack>
                        </Grid> */}

                        <Grid 
                            size={12}
                            width='100%'
                            display='flex'
                            direction='row'
                            justifyContent='center'
                            sx={{
                                pb: {xs: 2, md: 5}
                            }}
                        >
                            <Link 
                                to={companyData.contact.formLinks.contactUs} 
                                target="_blank"
                                data-aos="zoom-in"
                            >
                                <ButtonComponent 
                                    label={t('contact.sendMessage')}
                                    onClick={() => {}}
                                />
                            </Link>
                        </Grid>

                        <Grid size={{xs: 12, md: 6}} sx={{ display: "flex" }}>
                            <ContactInfo />
                        </Grid>

                        <Grid size={{xs: 12, md: 6}} sx={{ display: "flex" }}>
                            <BusinessHours />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default ContactInfoLayout;